export const LOAD_CATEGORIES_SUCCESS = "[CATEGORIES] LOAD_CATEGORIES_SUCCESS";
export const LOAD_CATEGORIES_FAILURE = "[CATEGORIES] LOAD_CATEGORIES_FAILURE";

export type SBCategory = {
  name: string;
  description: string;
};

interface LoadCategoriesSuccess {
  type: typeof LOAD_CATEGORIES_SUCCESS;
  payload: SBCategory[];
}

interface LoadCategoriesFailure {
  type: typeof LOAD_CATEGORIES_FAILURE;
  payload: object & { code: number | string };
}

export type CategoriesActionTypes =
  | LoadCategoriesSuccess
  | LoadCategoriesFailure;
